export default __webpack_public_path__ + "static/media/landscape11.8f9e7801.jpeg";